import { Mail } from '../../../types/smartClient';

import logFetch from '../../../utils/logFetch';
import logger from "../../../constants/logger";

const patchMail = async (endpoint: string, id: string, body: Partial<Mail>): Promise<{ status: number }> => {
    try {
        const logOptions = {
            fileName: __filename,
            section: '0',
            message: 'PATCH Mail',
        };

        const requestInit = {
            method: 'PATCH',
            headers: {
                Authorization: `Bearer ${(typeof chaynsInfo !== 'undefined' && chaynsInfo.User?.TobitAccessToken) || (typeof chayns !== 'undefined' && chayns.env.user.tobitAccessToken)}`,
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(body),
        };

        const response = await logFetch(`${endpoint}v1.0/me/Mails/${id}`, requestInit, logOptions);

        return {
            status: response.status,
        };
    } catch (ex) {
        logger().warning({
            message: 'Failed to patch mail',
            section: 'api/smart-client/patch/patchMail.js',
        }, {
            message: ex?.message,
        });
        return {
            status: 500,
        };
    }
};

export { patchMail };
